module.exports = __webpack_public_path__ + "static/media/tower.b45e1a4a.svg";